import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

/* Icons */
import ArrowIcon from '~/../symbols/arrow.svg';
import CrossIcon from '~/../symbols/cross.svg';

/* Images */
import placeholder from '~/../img/icons/placeholder.svg';

/* Common */
import { Icon } from '~/components/common';

/* Utilities */
import { getCloudimageUrl } from '~/utilities';

export default function ConversionFieldImage(props) {
    const { colClassName, field, component, path, id, addFiles, removeFiles } = props;
    const { label, required, disabled, value, name, multiple } = field;
    const files = component?.metadata?.[name];
    const file = files?.[0];

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const inputRef = useRef(null);

    return (
        <div className={`${colClassName}`}>
            <div className={`form-group form-group--flow form-group--flow-tradeproposal-image`}>
                <input
                    ref={inputRef}
                    className="d-none"
                    type="file"
                    id={id}
                    name={id}
                    {...{
                        required,
                        disabled,
                        multiple,
                    }}
                    onChange={(e) => {
                        const files = e?.target?.files;

                        removeFiles(value, () => {
                            addFiles(files, () => {
                                trigger(path);
                            });
                        });
                    }}
                />
                <label
                    className={`card card--white ${error ? 'border border-danger' : ''}`}
                    htmlFor={id}
                    onClick={(e) => {
                        if (!file) return;

                        e.preventDefault();
                        removeFiles(value, () => {
                            trigger(path);

                            if (inputRef?.current) {
                                inputRef.current.value = '';
                            }
                        });
                    }}
                >
                    <div className="card-body p-1">
                        <div className="d-flex align-items-center flex-nowrap">
                            <img
                                className="img-preview img-fluid"
                                src={getCloudimageUrl((file ? file?.path : `${window.location.origin}${placeholder}`), { w: 80, h: 80, func: 'crop' })}
                                alt={files?.length > 0 ? files.map((file) => file.name)?.join(', ') : label}
                                width="40"
                                height="40"
                            />
                            <p className="text--sm text-truncate m-0 pl-3">{files?.length > 0 ? files.map((file) => file.name)?.join(', ') : label}</p>
                            <div className="ml-auto pr-1">
                                <Icon
                                    theme="base"
                                    url={file ? CrossIcon?.url : ArrowIcon?.url}
                                    className={`icon--circle-sm bg-light ${file ? '' : 'rotate-n90'}`}
                                />
                            </div>
                        </div>
                    </div>
                </label>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
}
